'use strict';

function CreditScoreArticleGallery() {
  this.id = null;
  this.node = null;
  this.extends = [_CreditScoreController, ArticleGallery];

  this.contentId = ''; // 'credit-score' (defined in pug file)

  this.init = function () {
    // change content reference before controller creates product
    this._super();

    this.initPage();
  };

  this.initPage = function () {
    this.initArticleGallery();
  };

  this.initAllReady = function () {};

  this.destroy = function () {
    this.destroyArticleGallery();
  };
}